export default __webpack_public_path__ + "static/media/icon-benchToFloor.1bf5878d.svg";